import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import recordList from './recordList/reducer';
import recordDetail from './recordDetail/reducer';
import isinDetail from './isinDetail/reducer';
import staticData from './staticData/reducer';
import filterRecords from './filter/reducer';
import recentlyUsed from './recentlyUsed/reducer';
import legal from './legal/reducer';
import user from './user/reducer';
import errors from './errors/reducer';
import auth from './provider/reducer';
import admin from './admin/reducers';

const reducers = combineReducers({
  recordList,
  recordDetail,
  isinDetail,
  staticData,
  errors,
  filterRecords,
  recentlyUsed,
  legal,
  auth,
  user,
  admin,
  router: routerReducer
});
export default reducers;



// WEBPACK FOOTER //
// ./src/reducers.js